import { render, staticRenderFns } from "./ShiftInputForm.vue?vue&type=template&id=1961144c&scoped=true&"
import script from "./ShiftInputForm.vue?vue&type=script&lang=js&"
export * from "./ShiftInputForm.vue?vue&type=script&lang=js&"
import style0 from "./ShiftInputForm.vue?vue&type=style&index=0&id=1961144c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1961144c",
  null
  
)

export default component.exports